export default __webpack_public_path__ + "9320691773364abbffb2986789df9578.ttf";